import ROUTE_URLS from '../../constants/routeUrls';

/** Canonical Automation Studio URL patterns (post route-swap). */
export const AUTOMATION_STUDIO_ROUTES = {
    base: ROUTE_URLS.AUTOMATION_STUDIO,
    testCase: ROUTE_URLS.AUTOMATION_STUDIO_TEST_CASE,
};

export const AUTOMATION_STUDIO_LEGACY_PREVIEW_ROUTES = {
    base: ROUTE_URLS.AUTOMATION_STUDIO_NEW,
    testCase: ROUTE_URLS.AUTOMATION_STUDIO_NEW_TEST_CASE,
};
